import _ from 'lodash';

function buildBiEventData(biData) {
    const { userId, sellerId, activeGigsCount } = biData;

    return ({
        group: 'seller_page',
        user: {
            id: userId
        },
        seller: {
            id: sellerId,
            active_gigs_count: activeGigsCount
        }
    });
}

export function buildSellerCardData(
    seller_card,
    user_analytics = { response_time: { value: 0 } },
    { username = '' },
    currentUser = {},
    liveGigs = [],
    pageCtxId = '',
    rollouts = {}
) {

    const responseTime = user_analytics.response_time && user_analytics.response_time.value,
        isLoggedIn = !!(currentUser.username),
        userId = currentUser.id,
        activeGigsCount = liveGigs.length,
        biData = {
            userId,
            sellerId: seller_card.user.id,
            activeGigsCount
        };

    seller_card.user.response_time = responseTime;
    seller_card.user.contact_path = `/conversations/${username}`;
    seller_card.user.has_live_gigs = !!activeGigsCount;
    seller_card.user.rating = seller_card.user.rating || 0;

    seller_card.shouldShowReportUser = true;
    seller_card.allowEditing = false;
    seller_card.viewingAsBuyer = false;
    seller_card.isLoggedIn = isLoggedIn;
    seller_card.pageCtxId = pageCtxId;

    seller_card.biEventData = buildBiEventData(biData);

    if (!rollouts.studio) {
        seller_card.user.studio = {};
    }

    if (!rollouts.studio_leads) {
        seller_card.user.is_eligible_to_become_studio_member = false;
    }

    return {
        ...seller_card
    };
}

export function buildPortfolioData(portfolioShowcase, { username = '' }) {
    const link = `https://www.fiverr.com/users/${username}/portfolio?origin=seller_profile`,
        portfolioProjectsThumbs = portfolioShowcase.map((project) => ({ photo_url: project.item }));

    return {
        portfolioProjectsThumbs,
        link
    };
}

export function buildFiverrLearnData(fiverrLearnCourses) {
    return fiverrLearnCourses.map((course) => ({
        ...course,
        status_updated_at: new Date(course.status_updated_at).getTime()
    }));
}

export function buildProSubCategories(proSubCategories = []) {
    if (!proSubCategories) { return []; }

    return proSubCategories.map((subCat) =>
        ({ id: subCat, name: i18n.t(`sub_categories.sub_category_${subCat}.name`) })
    );
}

export function buildWideGigData(
    wideGigData = {},
    gigs = [],
    currency = {},
    csrfToken = ''
) {
    if (!wideGigData.packageList || _.isEmpty(wideGigData)) { return ({}); }

    return ({
        gigs,
        gig: wideGigData.gig,
        packageList: wideGigData.packageList,
        currency,
        csrfToken
    });
}



// WEBPACK FOOTER //
// ./src/common/dataBuilder.js